import Styles from '../ShapesTab.module.scss'
import { ColorSwatch } from 'components/Design/ColorSwatch/ColorSwatch'
import { HexColorInput } from 'components/HexColorInput/HexColorInput'
import { Text } from 'blaze-ui/Text/Text'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { SolidColor } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { Editor } from '@tldraw/tldraw'
import { getColors } from 'components/VisualStudioPlayground/VisualEditor/helpers'

interface Props {
  editor: Editor
  label: string
  color: string
  updateColor: (color: string) => void
  isDisabled?: boolean
}

export const ColorDetailRow = observer(({ editor, label, color, updateColor, isDisabled = false }: Props) => {
  const { designStore } = useRootStore()

  const handleColorPress = () => {
    if (!designStore) return

    const defaultColor: SolidColor = { type: 'solidColor', color: color, opacity: 1 }

    designStore.openPanel({
      type: 'colors',
      styleProp: null,
      defaultColor: defaultColor,
      colors: Array.from(getColors(editor).values()),
      onChange: (color) => {
        if (color.type === 'solidColor') updateColor(color.color)
      },
      allowTransparency: false,
      allowGradient: false,
    })
  }

  return (
    <>
      <Text variant="smallList">{label}</Text>
      <div className={Styles.colorField}>
        <ColorSwatch
          color={{ type: 'solidColor', opacity: 1, color: color }}
          size={30}
          onPress={handleColorPress}
          isDisabled={isDisabled}
        />
        <HexColorInput
          aria-label={label}
          name={label}
          className={Styles.input}
          color={color}
          onChange={(value) => updateColor(value)}
          size="sm"
          withBorder={false}
          disabled={isDisabled}
          autoComplete="off"
        />
      </div>
    </>
  )
})
